import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';

import {
  setPromptUserSignIn,
  setReferrer,
  setSignInLandingPage,
  setReferrerCallback,
  setVisitPaymentDetails,
  setSignInLandingPageState,
} from './actions';

import type { ReferrerCallbackFn } from './actions';

type RouteState = {
  promptUserSignIn: boolean;
  referrer: string | null;
  referrerCallback: ReferrerCallbackFn | null;
  signInLandingPage: string | null;
  signInLandingPageState: { isPurchasingPass: boolean } | null;
  visitPaymentDetails: {
    paymentErrorMessage?: string;
    totalPrice: number;
    visitId: number;
  } | null;
};

const initialState: RouteState = {
  referrer: null,
  signInLandingPage: null,
  signInLandingPageState: null,
  referrerCallback: null,
  visitPaymentDetails: null,
  promptUserSignIn: false,
};

const store = createStore(initialState);

type Reducers = {
  setPromptUserSignIn: {
    action: Event<boolean>;
    reducer: (state: RouteState, payload: boolean) => RouteState;
  };
  setReferrer: {
    action: Event<string | null>;
    reducer: (state: RouteState, payload: string | null) => RouteState;
  };
  setReferrerCallback: {
    action: Event<ReferrerCallbackFn | null>;
    reducer: (state: RouteState, payload: ReferrerCallbackFn | null) => RouteState;
  };
  setSignInLandingPage: {
    action: Event<string | null>;
    reducer: (state: RouteState, payload: string | null) => RouteState;
  };
  setSignInLandingPageState: {
    action: Event<{ isPurchasingPass: boolean } | null>;
    reducer: (state: RouteState, payload: { isPurchasingPass: boolean } | null) => RouteState;
  };
  setVisitPaymentDetails: {
    action: Event<{
      paymentErrorMessage?: string;
      totalPrice: number;
      visitId: number;
    } | null>;
    reducer: (
      state: RouteState,
      payload: {
        paymentErrorMessage?: string;
        totalPrice: number;
        visitId: number;
      } | null,
    ) => RouteState;
  };
};

export const reducers: Reducers = {
  setReferrer: {
    action: setReferrer,
    reducer: (state, payload) => ({
      ...state,
      referrer: payload,
    }),
  },
  setSignInLandingPage: {
    action: setSignInLandingPage,
    reducer: (state, payload) => ({
      ...state,
      signInLandingPage: payload,
    }),
  },
  setSignInLandingPageState: {
    action: setSignInLandingPageState,
    reducer: (state, payload) => ({
      ...state,
      signInLandingPageState: payload,
    }),
  },
  setReferrerCallback: {
    action: setReferrerCallback,
    reducer: (state, payload) => ({
      ...state,
      referrerCallback: payload,
    }),
  },
  setPromptUserSignIn: {
    action: setPromptUserSignIn,
    reducer: (state, payload) => ({
      ...state,
      promptUserSignIn: payload,
    }),
  },
  setVisitPaymentDetails: {
    action: setVisitPaymentDetails,
    reducer: (state, payload) => ({
      ...state,
      visitPaymentDetails: payload,
    }),
  },
};

export default applyReducers({ storeName: 'customer/route', store, reducers });
